<template>
    <el-dialog
        class="add"
        :visible.sync="selectShopVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Download"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="addForm" :model="addForm" @keydown.enter.native.prevent>
                <el-row v-if="select_shop.length == 0">
                    <div align="center" style="padding:20px">
                        <i class="el-icon-info el-info"></i>
                        <span>Collect the store to Download for FREE.</span><br><br><br>
                        <span><a style="text-decoration:underline" href="#" @click="addstore">Create a store</a></span>
                    </div>
                </el-row>    
                <el-row v-else>
                    <el-col :span="24" style="padding:20px">
                        <el-form-item 
                        label="Shop" 
                        size="small"
                        prop="shop_id"
                        :rules="[
                                {
                                    required: true,
                                    message: 'Please select a shop',
                                },
                            ]"
                        >
                            <el-select v-model="addForm.shop_id" placeholder="请选择" width="85%">
                                <el-option
                                v-for="item in select_shop"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="download"
                :loading="loading"
                v-if="select_shop.length > 0"
                >Dowmload</el-button
            >
            <el-button size="small" @click="selectShopVisible = false"
                >Close</el-button
            >
        </span>
        <generate :generateVisible.sync="generateVisible"></generate>
    </el-dialog>
    
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import generate from "@/common/components/generateDialog.vue";
import { mapActions } from "vuex";
export default {
    data() {
        return {
            select_shop:[],
            isDownload: false,
            generateVisible: false,
            addForm:{
                shop_id:''
            }
        };
    },
    methods: {
        download() {
            this.$refs["addForm"].validate(valid => {
                if (valid) {
                    cmofferApi.download({ id: this.id ,shop_id:this.addForm.shop_id}, "get").then((res) => {
                        if (res.errcode == 0) {
                            this.isDownload = true;
                            this.generateVisible = true;
                            this.closeDialog();
                        }
                    });
                }
            });
            
        },
        closeDialog() {
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:selectShopVisible", false);
        },
        addstore(){
            this.closeDialog();
            window.open("/storeList", '_blank');
        },
    },
    components: {
        generate,
    },
    props: {
        selectShopVisible: Boolean,
        id: Number
    },
    watch: {
        selectShopVisible() {
            if (this.selectShopVisible) {
                cmofferApi.shopSelect({user_id:1}, "get").then((res) => {
                    if (res) {
                        this.select_shop = res.data;
                    }
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.add {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }
        .el-select {
            width: 85%;
        }
        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
        .el-info {
            color: $color-primary;
            margin-right:10px
        }
    }
}
</style>
